import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full py-8 px-4 border-t border-slate-800/50 bg-slate-900/30 backdrop-blur-sm">
      <div className="max-w-4xl mx-auto">
        {/* Main Content */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 mb-6">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-violet-600 rounded-lg flex items-center justify-center">
              <img src="/logo192.png" alt="DeckLink Logo" className="w-5 h-5" />
            </div>
            <span className="text-lg font-light text-white">
              DeckLink<span className="text-blue-400">.co</span>
            </span>
          </a>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {/* <a
              href="https://twitter.com/decklink"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-blue-400 transition-colors p-2 hover:bg-slate-800/50 rounded-lg"
            >
              <Twitter className="h-4 w-4" />
            </a>
            <a
              href="https://linkedin.com/company/decklink"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-blue-400 transition-colors p-2 hover:bg-slate-800/50 rounded-lg"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="https://github.com/decklink"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-blue-400 transition-colors p-2 hover:bg-slate-800/50 rounded-lg"
            >
              <Github className="h-4 w-4" />
            </a> */}
            <a
              href="mailto:davies@decklink.co"
              className="text-slate-400 hover:text-blue-400 transition-colors p-2 hover:bg-slate-800/50 rounded-lg"
            >
              <Mail className="h-4 w-4" />
            </a>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-6 text-sm">
          <a href="#" className="text-slate-400 hover:text-white transition-colors">Features</a>
          <Link to="/pricing" className="text-slate-400 hover:text-white transition-colors">Pricing</Link>
          <a href="/blog" className="text-slate-400 hover:text-white transition-colors">Blog</a>
          <a href="/privacy-policy" className="text-slate-400 hover:text-white transition-colors">Privacy</a>
          <a href="/terms" className="text-slate-400 hover:text-white transition-colors">Terms</a>
          <a href="/help" className="text-slate-400 hover:text-white transition-colors">Help</a>
          <a href="mailto:hello@decklink.co" className="text-slate-400 hover:text-white transition-colors">Contact</a>
        </div>

        {/* Bottom Line */}
        <div className="border-t border-slate-800/50 pt-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
            <p>&copy; {new Date().getFullYear()} DeckLink.co</p>
            <p className="text-center sm:text-right">Empowering founders worldwide</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;